import { StyleGeneralIcon, StyleScribbleIcon } from '@blocksuite/icons/lit';
import { css } from 'lit';

import type { MenuItem } from './types';

export const LINE_STYLE_LIST = [
  {
    key: 'General',
    value: false,
    icon: StyleGeneralIcon(),
  },
  {
    key: 'Scribbled',
    value: true,
    icon: StyleScribbleIcon(),
  },
] as const satisfies MenuItem<boolean>[];

/**
 * The clip of a senior tool's artwork: cut at the bottom of its box (the toolbar's edge) only. The
 * parts a hover lifts rise above the toolbar instead of ending at the top of the box.
 */
export const SENIOR_TOOL_ART_CLIP = css`
  clip-path: inset(-100vh -100vw 0);
`;

/**
 * A senior tool's stage (`.senior-art`): its parts (`.art-part`) stand on the toolbar's edge and
 * move by `--x`, `--y`, `--r` and `--s`; `.art-card` is the paper card the toolbar's artwork is
 * made of. The stage takes the app's theme from `data-app-theme`.
 */
export const SENIOR_TOOL_ART = css`
  .senior-art {
    width: 100%;
    height: 64px;
    position: relative;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    cursor: pointer;
    ${SENIOR_TOOL_ART_CLIP}
  }
  .senior-art * {
    box-sizing: border-box;
  }
  .senior-art[data-app-theme='light'] {
    --art-card: #fff;
    --art-card-edge: rgba(0, 0, 0, 0.1);
    --art-card-shadow:
      0px 2px 4px rgba(0, 0, 0, 0.22), inset 0px -2px 1px rgba(0, 0, 0, 0.14);
    --art-ink: #7a7a7a;
    --art-ink-soft: rgba(0, 0, 0, 0.12);
  }
  .senior-art[data-app-theme='dark'] {
    --art-card: #343434;
    --art-card-edge: rgba(255, 255, 255, 0.12);
    --art-card-shadow:
      0px 2px 4px rgba(0, 0, 0, 0.6),
      inset 0px -2px 1px rgba(255, 255, 255, 0.06);
    --art-ink: #b4b4b4;
    --art-ink-soft: rgba(255, 255, 255, 0.14);
  }
  .art-part {
    position: absolute;
    bottom: 0;
    transform: translate(var(--x, 0px), var(--y, 0px)) rotate(var(--r, 0deg))
      scale(var(--s, 1));
    transition: transform 0.4s ease;
  }
  .art-part svg {
    display: block;
    width: 100%;
    height: 100%;
  }
  .art-card {
    background: var(--art-card);
    border: 1px solid var(--art-card-edge);
    box-shadow: var(--art-card-shadow);
    color: var(--art-ink-soft);
  }
`;

/** A quick tool's room in the dock row. */
export const EDGELESS_DOCK_QUICK_TOOL_WIDTH = 36;
/** A senior tool's room in the dock row; other views' drawn tools take the same. */
export const EDGELESS_DOCK_SENIOR_TOOL_WIDTH = 96;
